module.exports = __webpack_public_path__ + "img/ico-map.9e1f1190.svg";